import React from 'react';

function AboutMe() {
  return (
    <div className="container mt-5">
      <h2 className="mb-3">About Us</h2>
      <p>
        <strong>Conexsee</strong> is a student community platform designed to connect students
        with professionals and experts from various fields. We believe that early access to
        meaningful career insights and professional guidance can empower students to make better
        decisions for their future.
      </p>
      <p>
        The platform was built around the core value of <em>"being more connected"</em> — where
        knowledge, experience, and inspiration are shared to help students grow both personally
        and professionally.
      </p>
      <p>
        Conexsee provides a range of activities such as expert mentoring sessions, insight sharing
        events, and webinars to prepare students for real-world challenges. Whether you are a
        university student exploring your career path or a recent graduate seeking direction, we aim
        to support your journey with a collaborative and inclusive community.
      </p>
      <p>
        Together with our community, we continue to foster a culture of connection, curiosity,
        and continuous learning — because your future starts with who you connect with today.
      </p>
    </div>
  );
}

export default AboutMe;
